module.exports = __webpack_public_path__ + "img/eight8Green.ce7fdfb3.jpg";